import { useTenantConfig } from '../hooks/useTenantConfig';
import DashboardDetail from './analysis/DashboardDetail';

export default function Home() {
  const { data: tenantConfig } = useTenantConfig();

  const platformName = tenantConfig?.whitelabeling?.page_title
    || (window as any).__PLB_ENV__?.whitelabeling?.page_title
    || 'Pliable';

  if (tenantConfig?.default_dashboard_id) {
    return <DashboardDetail embeddedDashboardId={tenantConfig.default_dashboard_id} />;
  }

  return (
    <div className="flex flex-col items-center justify-center h-full p-8">
      <h1 className="text-3xl font-bold text-foreground mb-4">Welcome to {platformName}</h1>
      <p className="text-muted-foreground text-center max-w-md">
        Your low-code data platform for analytics and AI. Get started by exploring your data or chatting with Ellie.
      </p>
    </div>
  );
}
